/* Landing "Frequently Bought Together" carousel: drag to scroll, arrows and progress bar.
   The recommendations markup is inserted after load, so the element upgrades whenever it appears. */
if (!customElements.get('fbt-carousel-component')) {
  class FbtCarouselComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.bar = this.querySelector('[data-carousel-progress]');

      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      const stopDragging = () => {
        dragging = false;
        this.track.classList.remove('is-dragging');
      };
      this.track.addEventListener('mousedown', (event) => {
        dragging = true;
        this.track.classList.add('is-dragging');
        startX = event.pageX - this.track.offsetLeft;
        startScroll = this.track.scrollLeft;
      });
      this.track.addEventListener('mouseleave', stopDragging);
      this.track.addEventListener('mouseup', stopDragging);
      this.track.addEventListener('mousemove', (event) => {
        if (!dragging) return;
        event.preventDefault();
        this.track.scrollLeft = startScroll - (event.pageX - this.track.offsetLeft - startX) * 1.5;
      });

      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    step(direction) {
      const card = this.track.querySelector('.premium-carousel__item');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track.firstElementChild).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      if (this.bar) this.bar.style.setProperty('--prog', `${maximum > 0 ? (this.track.scrollLeft / maximum) * 100 : 0}%`);
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 0;
      if (this.nextButton) this.nextButton.disabled = maximum <= 0 || this.track.scrollLeft >= maximum - 1;
    }
  }

  customElements.define('fbt-carousel-component', FbtCarouselComponent);
}
